<template>
	<avue-form v-model="formPeriod" :option="optionPeriod" @submit="submitPeriod">
		<template slot="today" slot-scope="scope">
			<span>{{ scope.value }}</span>
		</template>
		<template slot="effectiveDate">
			<el-date-picker
				v-model="formPeriod.effectiveDate"
				:default-value="defaultValue"
				:disabled="isSubmitted"
				:picker-options="pickerOptions"
				format="yyyy-MM-dd"
				placeholder="请选择 生效日期"
				type="date"
				@change="effectiveDateChanged"></el-date-picker>
		</template>
		<template slot="period">
			<el-select v-model="formPeriod.period" :disabled="isSubmitted || periodList.length == 1" @change="periodChanged">
				<el-option v-for="item in periodList" :key="item.value" :label="item.label" :value="item.value"></el-option>
			</el-select>
		</template>
		<template slot="defeasanceDate" slot-scope="scope">
			<span>{{ scope.value }}</span>
		</template>
		<template slot="menuForm">
			<el-button v-if="isSubmitted" icon="el-icon-edit" @click="modifyPeriod">修改</el-button>
		</template>
	</avue-form>
</template>

<script>
import {checkEffectiveDate, getChannelMainInfo} from '@/api/insurance/policy'
import {mapGetters} from 'vuex'
import {toYYYYmmdd} from '@/util/date'

export default {
	name: 'PeriodForm',
	props: {
		minEffectiveDate: {
			type: Date | Number,
		},
		maxEffectiveDate: {
			type: Date | Number,
		},
		periodListTemp: {
			type: Array,
			required: true,
		},
	},
	computed: {
		...mapGetters(['userInfo']),
	},
	data() {
		return {
			optionPeriod: {
				submitBtn: true,
				submitText: '确认',
				emptyBtn: false,
				menuBtn: true,
				column: [
					{
						label: '当前日期',
						prop: 'today',
						span: 24,
						slot: true,
					},
					{
						label: '生效日期',
						prop: 'effectiveDate',
						span: 24,
						placeholder: '请选择 生效日期',
						slot: true,
						rules: [
							{
								required: true,
								message: '请选择 生效日期',
								trigger: 'change',
							},
						],
					},
					{
						label: '保障期限',
						prop: 'period',
						span: 24,
						slot: true,
						rules: [
							{
								required: true,
								message: '请选择 保障期限',
								trigger: 'change',
							},
						],
					},
					{
						label: '保险止期',
						prop: 'defeasanceDate',
						span: 24,
						slot: true,
					},
				],
			},

			formPeriod: {
				today: '',
				effectiveDate: '',
				period: '',
				defeasanceDate: '',
			},

			isSubmitted: false,

			pickerOptions: {
				disabledDate: () => {},
			},
			periodList: this.periodListTemp,
			isDealYear: false,
			defaultValue: Date.now(),
			minEffectiveDateTemp: '',
			maxEffectiveDateTemp: '',
		}
	},
	watch: {
		periodListTemp: {
			handler(newVal) {
				this.periodList = newVal
				if (!this.validatenull(newVal)) {
					if (!this.validatenull(this.periodList) && this.periodList.length == 1) {
						this.formPeriod.period = this.periodList[0].value
					}
				}
			},
		},
		minEffectiveDate: {
			handler(newVal = '') {
				if (!this.validatenull(newVal)) {
					this.minEffectiveDateTemp = newVal
				}
			},
			immediate: true,
		},
		maxEffectiveDate: {
			handler(newVal = '') {
				if (!this.validatenull(newVal)) {
					this.maxEffectiveDateTemp = newVal
					//处理延迟时间
					this.onDelayTime()
				}
			},
			immediate: true,
		},
	},
	created() {
		this.init()
	},
	activated() {
		console.log('onBusEffectiveData-----2')
		this.$Bus.$on('onBusEffectiveData', this.onChangeEffectiveData)
	},
	deactivated() {
		console.log('onBusEffectiveData-----3')
		this.$Bus.$off('onBusEffectiveData', this.onChangeEffectiveData)
	},
	methods: {
		init() {
			this.formPeriod.today = this.getDateString(new Date())
		},
		submitPeriod(form, done) {
			let dateInfo = {
				effectiveDate: this.getDateString(form.effectiveDate),
			}
			//  查询保单起始日期是否有效
			checkEffectiveDate(Object.assign(dateInfo))
				.then((response) => {
					this.$message({
						message: '确认 成功',
						type: 'success',
					})

					this.optionPeriod.column.forEach((item, index) => {
						if (item.prop == 'effectiveDate') {
							item.disabled = true
						}
					})
					this.optionPeriod.submitBtn = false

					this.isSubmitted = true

					this.$emit('onSubmitted', this.getSubmitData())
				})
				.catch(() => {})
				.finally(() => {
					done()
				})
		},
		modifyPeriod() {
			this.optionPeriod.submitBtn = true

			this.isSubmitted = false

			this.$emit('onUnsubmitted')
		},
		effectiveDateChanged(val) {
			this.calcDefeasanceDate()
			this.$emit('periodChange')
		},
		periodChanged(val) {
			this.calcDefeasanceDate()
			this.$emit('periodChange')
		},
		getData() {
			return this.formPeriod
		},
		getSubmitData() {
			let dataSubmit = {
				effectiveDate: !this.validatenull(this.formPeriod.effectiveDate)
					? this.getDateString(this.formPeriod.effectiveDate)
					: '',
				expiryDate: this.formPeriod.defeasanceDate || '',
				term: this.formPeriod.period || '',
			}

			return dataSubmit
		},
		setData(data) {
			Object.assign(this.formPeriod, data)
			this.calcDefeasanceDate()
		},
		// 计算保单失效日期
		calcDefeasanceDate() {
			var beginDate = this.formPeriod.effectiveDate
			var period = this.formPeriod.period

			if (!this.validatenull(beginDate)) {
				if (beginDate.getTime() < this.minEffectiveDateTemp || beginDate.getTime() > this.maxEffectiveDateTemp) {
					this.formPeriod.effectiveDate = ''
				} else {
					if (!this.validatenull(period)) {
						this.formPeriod.defeasanceDate = this.timeTransformation(beginDate, period) + ' 23:59:59'
					}
				}
			}
		},
		getDateString(date) {
			if (this.validatenull(date)) {
				return ''
			}
			let year = date.getFullYear()
			let month = date.getMonth() + 1
			if (month < 10) {
				month = '0' + month
			}
			var day = date.getDate()
			if (day < 10) {
				day = '0' + day
			}
			return year + '-' + month + '-' + day
		},
		// 从生效日期date向后num个自然月
		timeTransformation(date, num) {
			if (this.validatenull(date)) {
				return ''
			}
			let year = date.getFullYear()
			let month = date.getMonth()
			let day = date.getDate()

			year = year + parseInt((month + num) / 12)
			month = (month + num) % 12

			var maxDayCount = new Date(year, month + 1, 0).getDate()

			if (day > maxDayCount) {
				day = maxDayCount
			}

			var newDate = new Date(year, month, day - 1)

			year = newDate.getFullYear()
			month = newDate.getMonth()
			day = newDate.getDate()

			month += 1

			if (month < 10) {
				month = '0' + month
			}
			if (day < 10) {
				day = '0' + day
			}

			return year + '-' + month + '-' + day
		},
		//如果去除投保年，切换企业可投年，则添加
		addYear() {
			if (this.isDealYear) {
				this.periodList.unshift({
					label: '1年',
					value: '12',
				})
				this.isDealYear = false
			}
		},
		//去除投保年，并且把状态调整为确认
		removeYear() {
			if (this.isDealYear) {
				return
			}
			this.periodList = this.periodList.filter((itemData) => {
				return itemData.value != 12
			})
			if (this.isSubmitted && this.formPeriod.period == 12) {
				//如果选年了，则重新选
				//去掉label
				this.formPeriod.period = ''
				this.formPeriod.defeasanceDate = ''
				this.modifyPeriod()
			}
			this.isDealYear = true
		},
		//处理延迟生效时间
		async onDelayTime() {
			//获取主渠道参数
			let {distAccount = {}} = this.userInfo
			let insureStartDaysTemp = 0
			if (!this.validatenull(distAccount)) {
				let result = await getChannelMainInfo()
				let {insureStartDays = '0'} = result.data.data || {}
				insureStartDaysTemp = parseInt(insureStartDays) * 24 * 60 * 60 * 1000
			}
			this.pickerOptions = {
				disabledDate: (time) => {
					let result
					if (!this.validatenull(this.maxEffectiveDateTemp)) {
						result =
							time.getTime() > this.maxEffectiveDateTemp ||
							time.getTime() < this.minEffectiveDateTemp + insureStartDaysTemp
					} else {
						result = time.getTime() < this.minEffectiveDateTemp + insureStartDaysTemp
					}
					return result
				},
			}
		},
		onChangeEffectiveData({minEffDate = '', maxEffDate = ''}) {
			//通过企业改变方案名称
			let tempMin = toYYYYmmdd(this.minEffectiveDateTemp)
			let tempMax = toYYYYmmdd(this.maxEffectiveDateTemp)
			console.log(
				'onChangeEffectiveData -------',
				minEffDate,
				maxEffDate,
				'---',
				tempMin,
				tempMax,
				'----',
				this.minEffectiveDateTemp,
				this.maxEffectiveDateTemp,
			)
			if (minEffDate !== '' && maxEffDate !== '' && (tempMin !== minEffDate || tempMax !== maxEffDate)) {
				//设置生效，和失效日期
				this.optionPeriod.column.forEach((itemData) => {
					let {prop} = itemData
					if (prop === 'effectiveDate') {
						let {effectiveDate = ''} = this.formPeriod
						if (effectiveDate !== '') {
							this.formPeriod.effectiveDate = ''
							this.formPeriod.expiryDate = ''

							setTimeout(() => {
								this.$alert('因保司核保政策调整，生效日期发生改变，需要重新选择，带来不便，敬请谅解！', '提示').then(
									() => {},
								)
								this.$emit('onChangeEffDate')
								this.modifyPeriod()
							}, 600)
						}
						this.maxEffectiveDateTemp = Date.parse(`${maxEffDate} 00:00:00`)
						this.minEffectiveDateTemp = Date.parse(`${minEffDate} 00:00:00`)
					}
				})
			}
		},
	},
}
</script>
